@for (selection of selections(); track selection.name) {
    <bs-linear-bet-builder-selection-display [selection]="selection" [inlineDetails]="!!inlineDetails()"></bs-linear-bet-builder-selection-display>
}
